import CompactPill from 'v2/components/CompactPill';
import StatusPillLabel from 'v2/components/text/StatusPillLabel';

import { TEST_ID, getStatusClass } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CertificationStatusPill: FunctionComponent<Props> = ({
    className = '',
    status,
    testId = TEST_ID,
    text,
    title
}) => (
    <CompactPill
        className={`${styles.certificationStatusPill} ${getStatusClass(status)} ${className}`}
        testId={testId}
        title={title}
    >
        {status ? <span className={styles.statusDot} /> : null}

        <StatusPillLabel text={text} />
    </CompactPill>
);

export default CertificationStatusPill;
